module.exports = __webpack_public_path__ + "media/application/images/icons/innovations/time-850574d1cf71d993900c5b7bdbff1755.svg";